<template>
  <div class="bg_color">
    <div v-if="platformInfo.appId === '74web89ynsg'">
      <div class="footer_box">
        <span @click="goBeian" style="cursor: pointer;">©2017　81联聘 - 京ICP备17035848号-1</span>
        <span>服务邮箱：hr@81lianpin.com</span>
        <span>服务热线：010-84243158(9:00 -18:00)</span>
        <a class="licensebtn" :href="`/businessLicense`" target="_blank"><span>营业执照</span></a>
        <a class="licensebtn" :href="`/humanLicense`" target="_blank"><span>人力资源服务许可证</span></a>
        <a class="licensebtn" :href="`/legalstatement`" target="_blank"><span>法律声明</span></a>
      </div>
      <p style=" color: #fff;text-align: center;line-height: 30px; display: flex;justify-content: center;">
         <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502049182" style=" align-items: center;color: #fff;margin-right:40px ; display: flex;justify-content: center; "> 
            <img src="https://oss.81lianpin.com/picture/57/56/e7/7b52f9674dddb24eca7f9e81785756e7.png" style="width:20px;height:20px;margin-right:5px"/>
            京公网安备 11010502049182号
        </a>
        <span>朝阳区人力资源与社会保障局 监督电话：57596212、65090445</span>
      </p>
    </div>

    <template v-else>
      <div class="footer_box" >
        <span v-if="platformInfo.appId === '2DW29x025k8' || platformInfo.appId === 'GDs7Yz9HVP9Y'">{{this.platformInfo.remark1}}</span>
        <span  v-else-if="platformInfo.appId !== 'app71rrf9ksr'">{{this.platformInfo.provinceName}}退役军人事务厅主管</span>
        
        <span>北京军融英杰信息技术服务有限公司版权所有</span>
        <span v-if="platformInfo.appId != '2DW29x025k8'" @click="goBeian" style="cursor: pointer;">©2017　81联聘 - 京ICP备17035848号-1</span>
        <span v-if="platformInfo.appId == '2DW29x025k8'" @click="goBeian" style="cursor: pointer;">©2017　81联聘 - 京ICP备17035848号-2</span>
        <span>服务邮箱：hr@81lianpin.com</span>
        <span>服务热线：010-84243158(9:00 -18:00)</span>
      </div>
      <p>
        <a target="_blank" :href="`http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=${platformInfo.appId != '2DW29x025k8'? '11010502049182' : '11010502049322'}`" style=" color: #fff;text-align: center;line-height: 30px;    display: flex;justify-content: center;align-items: center;"> 
            <img src="https://oss.81lianpin.com/picture/57/56/e7/7b52f9674dddb24eca7f9e81785756e7.png" style="width:20px;height:20px;margin-right:5px"/>
            京公网安备 {{ platformInfo.appId != '2DW29x025k8'? '11010502049182' : '11010502049322'}}号
        </a>
      </p>
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  data() {
    return {

    }
  },
  created() {
  },
  computed: {
    ...mapState(['platformInfo'])
  },
  methods: {
    //  京ICP备17035848号-1
    goBeian(){
      window.location.href = "https://beian.miit.gov.cn/"
    }
  }
}
</script>

<style scoped>
.footer_box {
  width: 1200px;
  height: 30px;
  line-height: 30px;
  margin: 0 auto;
  color: #fff;
  display: flex;
  justify-content: center;
}
.footer_box span {
  margin: 0 20px;
}
.licensebtn {
  color: #1ebffb;
  text-decoration: underline;
}
</style>


// WEBPACK FOOTER //
// src/components/Footer.vue